import { useMutation, useQueryClient } from '@tanstack/react-query'

import { signOut } from '../api/sign-in'

export function useSignOut() {
  const qc = useQueryClient()

  return useMutation({
    mutationFn: () => signOut(),
    onSuccess: () => {
      qc.clear()
      window.location.assign('/sign-in')
    },
  })
}
